// App.js
import React from "react";
import { Routes, Route } from 'react-router-dom';
import MessageComponent from "./components/MessageComponent";
import "./App.css"; // Import your CSS file for global styles
import Header from "./components/Header.js";


const App = () => {
  return (
    <div className="app-container">
      <Header /> {/* Include the Header component */}
      <Routes>
      <Route path="/" element={<MessageComponent />} />
      <Route path="/:organizationId" element={<MessageComponent />} />
    </Routes>
    </div>
  );
};

export default App;
